import React, { useState } from "react";
import { useSelector } from "react-redux";
import Edit from "../../../assets/Edit";
import UpdateProfileModal from "./UpdateProfileModal";
import ResetPasswordModal from "./ResetPasswordModal";
import LoadableButton from "../../../components/button/LoadableButton";
import { getInitials } from "../../../utils/utils";
import { Avatar } from "antd";
import { Cookies } from "react-cookie";
import CryptoJS from "crypto-js";
import siteConfig from "../../../config";
import RightArrow from "../../../assets/RightArrow";

const Information = ({ client, setClient }) => {
  const userDetails = useSelector((state) => state?.user?.userDetails);
  const [isUpdateProfileModal, setIsUpdateProfileModal] = useState(false);
  const [isResetPasswordModal, setIsResetPasswordModal] = useState(false);

  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const handleClientLogin = async () => {
    const cookies = new Cookies();
    const { token } = cookies.getAll();
    const data = JSON.stringify({ token, clientId: client?.id });
    const encrypted = CryptoJS.AES.encrypt(data, secretKey);
    const safeCiphertext = encrypted.toString();

    const redirectUrl = `${siteConfig?.clientUrl
      }/admin_login?token=${encodeURIComponent(safeCiphertext)}`;
    window.open(redirectUrl);
  };

  return (
    <div>
      <div className="m-4">
        <div className="md:col-span-2 border rounded-lg">
          <div className="p-4 flex items-center justify-between">
            <p className="text-lg sub-title">Account details</p>

            <div className="flex items-center gap-2">
              <LoadableButton
                className="!px-4"
                lable="Reset password"
                onClick={() => setIsResetPasswordModal(true)}
              />
              {userDetails?.role === "admin" && (
                <LoadableButton
                  className="!px-4"
                  lable="Login"
                  onClick={handleClientLogin}
                >
                  Login <RightArrow />
                </LoadableButton>

              )}
            </div>
          </div>

          <div className="border-y mx-4 mb-4 flex items-center gap-5 p-4">
            <div className="flex items-center gap-6">
              <div className="relative">
                <Avatar
                  size="large"
                  className="uppercase size-32 text-4xl"
                  src={client?.profile_image}
                >
                  {getInitials(client?.name)}
                </Avatar>
                <button
                  className="bg-primary p-2 rounded-full cursor-pointer absolute bottom-1 right-2"
                  onClick={() => setIsUpdateProfileModal(true)}
                >
                  <Edit color="#ffffff" />
                </button>
              </div>
            </div>
            <div>
              <p className="text-lg sub-title capitalize">{client?.name}</p>
              <p className="text-secondaryLight2 capitalize">
                {client?.account_type}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-12 mx-4 mb-4 md:px-4">
            <div className="w-full flex flex-col gap-2">
              <div className="flex gap-5">
                <p className="font-medium w-20">Email</p>
                <p>{client?.email || "--"}</p>
              </div>
              <div className="flex gap-5">
                <p className="font-medium w-20">Phone</p>
                <p>{client?.mobile_no || "--"}</p>
              </div>
              <div className="flex gap-5">
                <p className="font-medium w-20">Status</p>
                <p>{client?.status || "--"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UpdateProfileModal
        client={client}
        setClient={setClient}
        isOpen={isUpdateProfileModal}
        setIsOpen={setIsUpdateProfileModal}
      />

      <ResetPasswordModal
        client={client}
        isOpen={isResetPasswordModal}
        setIsOpen={setIsResetPasswordModal}
      />
    </div>
  );
};

export default Information;
